import * as React from 'react';
import './receiptView.module.scss';
import { observer } from 'mobx-react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { ReceiptViewState } from './states/ReceiptViewState';
import { observable, makeObservable } from 'mobx';
import { Page } from '../../components/atoms/layout/Page';
import { Layout } from '../courses/CourseShowPage';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import moment from 'moment-timezone';
import { HeaderLogo } from '../../components/atoms/Logo';

type Props = {
  match: {
    params: {
      code: string;
    };
  };
};

export const ReceiptView = withNavigation(NavigationSpecs.none())(
  observer(
    class ReceiptView extends React.Component<Props> {
      pageState = new ReceiptViewState();

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });
      }

      async componentDidMount() {
        const { code } = this.props.match.params;
        this.pageState.init(code);
      }

      render() {
        const { payment: paymentResource } = this.pageState;
        if (paymentResource.loading) {
          return (
            <Layout>
              <Page styleName="page">
                <LoaderRow />
              </Page>
            </Layout>
          );
        }
        const payment = paymentResource.get();
        const search = window.location.search;
        const queryStrings = new URLSearchParams(search);
        const name = queryStrings.get('name');
        const purpose = queryStrings.get('purpose');
        const appelation = queryStrings.get('appelation');

        return (
          <div styleName="print-page">
            <div styleName="print">
              <Button type="primary" size="m" onClick={() => window.print()}>
                このページを印刷する
              </Button>
            </div>
            <div styleName="receipt">
              <h1>
                領収書
                <small>
                  <span>発行日：</span>
                  {moment().format('YYYY年MM月DD日')}
                  <br />
                  <span>領収書ID：</span>
                  {payment.code}
                </small>
              </h1>
              <hr />
              <div styleName="name">
                宛名：
                <span>
                  {name} {appelation}
                </span>
              </div>
              <div styleName="amount">
                {payment.amount.toLocaleString('ja-JP', {
                  style: 'currency',
                  currency: 'JPY',
                })}
                <small>
                  （内消費税
                  {payment.tax_amount.toLocaleString('ja-JP', {
                    style: 'currency',
                    currency: 'JPY',
                  })}
                  ）
                </small>
              </div>
              <div styleName="purpose">
                <p>
                  但: <span>{purpose}</span> として上記の金額、正に領収いたしました
                </p>
              </div>
              <div styleName="address">
                〒107-0062
                <br />
                東京都港区南青山3-7-21
                <br />
                SHE株式会社
              </div>
              <div className="logo">
                <HeaderLogo styleName="logo" />
              </div>
            </div>
          </div>
        );
      }
    }
  )
);
